// store/modules/ibpKanban.js
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  namespaced: true,
  state: {
    isLoading: null,
    columns: [
      {
        id: uuidv4(),
        name: 'ОП / Оплата',
        name_ru: 'ОП / Оплата',
        name_kz: 'Сату бөлімі',
        name_en: 'Sales Department',
        color: '#50C700',
        techcards: [],
      },
      {
        id: uuidv4(),
        name: 'Типография(тираж)',
        name_ru: 'Типография(тираж)',
        name_kz: 'Баспа(тираж)',
        name_en: 'Printing (Circulation)',
        color: '#00C793',
        techcards: [],
      },
      {
        id: uuidv4(),
        name: 'Типография(ППР)',
        name_ru: 'Типография(ППР)',
        name_kz: 'Баспа(БКЖ)',
        name_en: 'Printing (WAP)',
        color: '#00C793',
        techcards: [],
      },
      {
        id: uuidv4(),
        name: 'Склад(типография)',
        name_ru: 'Склад(типография)',
        name_kz: 'Қойма(баспа)',
        name_en: 'Stock(Printing House)',
        color: '#50C003',
        techcards: [],
      },
      {
        id: uuidv4(),
        name: 'Сдан',
        name_ru: 'Сдан',
        name_kz: 'Тапсырылған',
        name_en: 'Delivered',
        color: '#50C003',
        techcards: [],
      },
    ],
  },
  getters: {
    columns: (state) => state.columns,
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    setColumns(state, offers) {
      // очищаем колонки
      state.columns.forEach((column) => (column.techcards = []));

      offers.forEach((offer) => {
        const printingStatuses = [
          'in process',
          'accept',
          'Invoice and contract sent',
          'Request for invoice',
        ];

        if (printingStatuses.includes(offer.status)) {
          state.columns
            .find((col) => col.name === 'ОП / Оплата')
            ?.techcards.push(offer);
        }

        if (offer.status === 'typo_finish') {
          state.columns
            .find((col) => col.name === 'Типография(тираж)')
            ?.techcards.push(offer);
        }

        if (offer.status === 'wap') {
          state.columns
            .find((col) => col.name === 'Типография(ППР)')
            ?.techcards.push(offer);
        }

        if (offer.status === 'stock') {
          state.columns
            .find((col) => col.name === 'Склад(типография)')
            ?.techcards.push(offer);
        }

        if (offer.status === 'done') {
          state.columns
            .find((col) => col.name === 'Сдан')
            ?.techcards.push(offer);
        }
      });
    },

    updateOfferState(state, updatedOffer) {
      // Удаляем оффер из всех колонок
      state.columns.forEach((col) => {
        col.techcards = col.techcards.filter(
          (card) => card.id !== updatedOffer.id
        );
      });

      const statusToColumnName = {
        'in process': 'Отдел продаж',
        accept: 'Отдел продаж',
        'Invoice and contract sent': 'Отдел продаж',
        'Request for invoice': 'Отдел продаж',
        typo_finish: 'Типография(тираж)',
        wap: 'Типография(ППР)',
        stock: 'Склад(типография)',
        done: 'Сдан',
      };

      const columnName = statusToColumnName[updatedOffer.status];
      const column = state.columns.find((col) => col.name === columnName);

      if (column) {
        column.techcards.push(updatedOffer);
      } else {
        console.warn(`IBP: column not found for status: ${updatedOffer.status}`);
      }
    },

    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },

    setError(state, error) {
      console.error('IBP Kanban error:', error);
      toast.error(`Error: ${error}`, { timeout: 2000 });
    },
  },
  actions: {
    // подгружаем ИБП-офферы и раскидываем по колонкам
    async fetchIbpOffers({ commit, dispatch, rootGetters }) {
      commit('setLoading', true);
      try {
        // дергаем модуль offersIbp
        await dispatch('offersIbp/fetchOffers', null, { root: true });

        const offers = rootGetters['offersIbp/offers'] || [];

        // тут можно добавить фильтры, если нужно:
        // например, только активные и т.п.

        commit('setColumns', offers);
      } catch (error) {
        commit('setError', error);
      } finally {
        commit('setLoading', false);
      }
    },

    // обновление статуса оффера по перетаскиванию
    async updateOfferKanban({ commit }, { updatedProperties }) {
      try {
        const token = localStorage.getItem('token');

        // ⚠️ если у вас другой эндпоинт — поменяйте URL
        const response = await axios.post(
          'https://apidash.smartpress.kz/api/offer/update-status',
          updatedProperties,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        commit('updateOfferState', response.data.offer);
        toast.success('IBP offer updated successfully', { timeout: 2000 });
      } catch (error) {
        console.error('Failed to update IBP offer:', error);
        commit('setError', error);
        toast.error('Failed to update IBP offer', { timeout: 2000 });
      }
    },
  },
};
